import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetHistoricoClienteResponse } from '@shared/services/responses/vendas/get-historico-cliente.response';

/** Controller Venda da API Vendas, para o que não precisa de orquestração. */
@Injectable({
    providedIn: 'root',
})
export class VendaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiVendas + 'Venda';

    constructor(private httpClient: HttpClient) {
        super();
    }

    /**
     * As últimas vendas do cliente de UM tipo de documento — aba "Vendas" das últimas vendas do
     * cadastro de Pessoa. O nome e a cor da etapa moram no próprio db_vendas.
     */
    public getHistoricoDoCliente(
        idPessoaCliente: number, vendaTipoDocumento: number, quantidade: number = 10,
    ): Observable<GetHistoricoClienteResponse> {
        const params = new HttpParams()
            .set('quantidade', quantidade.toString())
            .set('vendaTipoDocumento', vendaTipoDocumento.toString());

        return this.httpClient
            .get<GetHistoricoClienteResponse>(
                `${this.apiUrl}/cliente/idPessoa/${idPessoaCliente}/historico`,
                { params, ...this.addHeaderToken() },
            )
            .pipe(catchError(this.handleError));
    }
}
